import { sendToMixpanel } from '../mixpanel';

export default ({ isAgency }: { isAgency: boolean }): void =>
  sendToMixpanel(`Reveal ${isAgency ? 'Agency' : 'Agent'} Phone`, {
    enquiryCTA: 'Profile Card Phone Button',
  });
